export default __webpack_public_path__ + "static/media/deddood_nft.463797ea.png";